module.exports = __webpack_public_path__ + "img/button6.dea15295.png";